import { render, staticRenderFns } from "./ProductCategoryForm.pug?vue&type=template&id=23d804c8&scoped=true&lang=pug&"
import script from "./ProductCategoryForm.js?vue&type=script&lang=js&"
export * from "./ProductCategoryForm.js?vue&type=script&lang=js&"
import style0 from "./ProductCategoryForm.sass?vue&type=style&index=0&id=23d804c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d804c8",
  null
  
)

component.options.__file = "ProductCategoryForm.vue"
export default component.exports